import { render, staticRenderFns } from "./fundDetails.vue?vue&type=template&id=08b10810&scoped=true"
import script from "./fundDetails.vue?vue&type=script&lang=js"
export * from "./fundDetails.vue?vue&type=script&lang=js"
import style0 from "./fundDetails.vue?vue&type=style&index=0&id=08b10810&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b10810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b10810')) {
      api.createRecord('08b10810', component.options)
    } else {
      api.reload('08b10810', component.options)
    }
    module.hot.accept("./fundDetails.vue?vue&type=template&id=08b10810&scoped=true", function () {
      api.rerender('08b10810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/red_packet_pool_management/red_packet_pool/form/fundDetails.vue"
export default component.exports